import { Icon } from '@dev-spendesk/grapes';

import { type WizardItemStatus } from './wizardModels';

export type WizardHeaderProps = {
  title: string;
  index: number;
  status: WizardItemStatus;
};

export const WizardHeader = ({ title, index, status }: WizardHeaderProps) => {
  let iconBackgroundClass = 'bg-background-secondary-default';
  if (status === 'completed') {
    iconBackgroundClass = 'bg-background-primary-default';
  } else if (status === 'current') {
    iconBackgroundClass = 'bg-background-secondary-brand-default';
  }

  return (
    <div className="m-8 flex items-center gap-8">
      <div
        className={`rounded-8 flex h-32 w-32 items-center justify-center ${iconBackgroundClass}`}
      >
        {status === 'completed' ? (
          <Icon
            name="circle-check"
            size="m"
            className="text-content-success-default"
          />
        ) : (
          <p>{index}</p>
        )}
      </div>
      <p className="title-m align-center text-content-primary">{title}</p>
    </div>
  );
};
